export default {
    formulary: {
        id: 1
    },
    token: {
        id: 2
    }
};
